import React from 'react';

import './styles.css';

const Loyalty = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Outline"
    height="512px"
    viewBox="0 0 512 512"
    width="512px"
    className="icon loyalty-icon"
  >
    <g>
      <path
        d="m488 16h-48a8 8 0 0 0 0 16h40v40a8 8 0 0 0 16 0v-48a8 8 0 0 0 -8-8z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m24 80a8 8 0 0 0 8-8v-40h40a8 8 0 0 0 0-16h-48a8 8 0 0 0 -8 8v48a8 8 0 0 0 8 8z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m488 432a8 8 0 0 0 -8 8v40h-40a8 8 0 0 0 0 16h48a8 8 0 0 0 8-8v-48a8 8 0 0 0 -8-8z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m24 496h48a8 8 0 0 0 0-16h-40v-40a8 8 0 0 0 -16 0v48a8 8 0 0 0 8 8z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m48 56v144a8 8 0 0 0 8 8h144a8 8 0 0 0 8-8v-144a8 8 0 0 0 -8-8h-144a8 8 0 0 0 -8 8zm16 8h128v128h-128z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m168 80h-80a8 8 0 0 0 -8 8v80a8 8 0 0 0 8 8h80a8 8 0 0 0 8-8v-80a8 8 0 0 0 -8-8zm-8 80h-64v-64h64z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m168 336h-80a8 8 0 0 0 -8 8v80a8 8 0 0 0 8 8h80a8 8 0 0 0 8-8v-80a8 8 0 0 0 -8-8zm-8 80h-64v-64h64z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m424 80h-80a8 8 0 0 0 -8 8v80a8 8 0 0 0 8 8h80a8 8 0 0 0 8-8v-80a8 8 0 0 0 -8-8zm-8 80h-64v-64h64z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m312 207.5h144a8 8 0 0 0 8-8v-143.5a8 8 0 0 0 -8-8h-144a8 8 0 0 0 -8 8v143.5a8 8 0 0 0 8 8zm8-143.5h128v127.5h-128z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m48 456a8 8 0 0 0 8 8h144a8 8 0 0 0 8-8v-144a8 8 0 0 0 -8-8h-144a8 8 0 0 0 -8 8zm16-136h128v128h-128z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m232 112a8 8 0 0 0 8-8v-40h8a8 8 0 0 0 0-16h-16a8 8 0 0 0 -8 8v48a8 8 0 0 0 8 8z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <circle
        cx="280"
        cy="56"
        r="8"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m264 112h16a8 8 0 0 0 8-8v-16a8 8 0 0 0 -16 0v8h-8a8 8 0 0 0 0 16z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m280 136h-16a8 8 0 0 0 -8 8v32a8 8 0 0 0 16 0v-24h8a8 8 0 0 0 0-16z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m232 208h48a8 8 0 0 0 0-16h-40v-56a8 8 0 0 0 -16 0v64a8 8 0 0 0 8 8z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m296 400a8 8 0 0 0 -8 8v40h-24a8 8 0 0 0 0 16h32a8 8 0 0 0 8-8v-48a8 8 0 0 0 -8-8z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <circle
        cx="232"
        cy="456"
        r="8"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m232 432a8 8 0 0 0 8-8v-8h24a8 8 0 0 0 0-16h-32a8 8 0 0 0 -8 8v16a8 8 0 0 0 8 8z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m232 320a8 8 0 0 0 8-8v-40h16a8 8 0 0 0 0-16h-24a8 8 0 0 0 -8 8v48a8 8 0 0 0 8 8z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m232 240h48v40a8 8 0 0 0 16 0v-48a8 8 0 0 0 -8-8h-56a8 8 0 0 0 0 16z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m48 280a8 8 0 0 0 8 8h48a8 8 0 0 0 0-16h-40v-8a8 8 0 0 0 -16 0z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m88 256a8 8 0 0 0 8-8v-16a8 8 0 0 0 -8-8h-32a8 8 0 0 0 0 16h24v8a8 8 0 0 0 8 8z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m120 224a8 8 0 0 0 -8 8v16a8 8 0 0 0 8 8h48a8 8 0 0 0 0-16h-40v-8a8 8 0 0 0 -8-8z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m208 232a8 8 0 0 0 -16 0v40h-56a8 8 0 0 0 0 16h64a8 8 0 0 0 8-8z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m464 232a8 8 0 0 0 -8-8h-48a8 8 0 0 0 0 16h40v8a8 8 0 0 0 16 0z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <circle
        cx="320"
        cy="312"
        r="8"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m432 280v-16a8 8 0 0 0 -16 0v8h-32a8 8 0 0 0 0 16h40a8 8 0 0 0 8-8z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m424 368h-32a8 8 0 0 0 0 16h24v8a8 8 0 0 0 16 0v-16a8 8 0 0 0 -8-8z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <circle
        cx="424"
        cy="424"
        r="8"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <circle
        cx="360"
        cy="376"
        r="8"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m392 416h-24v-8a8 8 0 0 0 -16 0v16a8 8 0 0 0 8 8h32a8 8 0 0 0 0-16z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m352 256a8 8 0 0 0 -8 8v48a8 8 0 0 0 8 8h39a8 8 0 0 0 0-16h-31v-40a8 8 0 0 0 -8-8z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m376 224h-56a8 8 0 0 0 -8 8v48a8 8 0 0 0 16 0v-40h48a8 8 0 0 0 0-16z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m232 384h64a8 8 0 0 0 8-8v-32a8 8 0 0 0 -8-8h-64a8 8 0 0 0 -8 8v32a8 8 0 0 0 8 8zm8-32h48v16h-48z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m328 464h128a8 8 0 0 0 8-8v-112a8 8 0 0 0 -8-8h-128a8 8 0 0 0 -8 8v112a8 8 0 0 0 8 8zm8-112h112v96h-112z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m288 304h-15a8 8 0 0 0 0 16h15a8 8 0 0 0 0-16z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
      <path
        d="m464 280a8 8 0 0 0 -16 0v24h-24a8 8 0 0 0 0 16h32a8 8 0 0 0 8-8z"
        data-original="#000000"
        class="active-path"
        data-old_color="#000000"
        fill="currentColor"
      />
    </g>{' '}
  </svg>
);

export default Loyalty;
